import modalStyle from "../modal.module.scss";

import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { SolidButton } from "components/buttons/SolidButton";

const LandingView = ({
  viewStateEnum,
  getViewTitle,
  changeViewState,
  onCloseModal,
}) => {
  const theme = useTheme();

  // Status
  // Method
  // Side effect

  const hereElement = (
    <Box
      component="span"
      sx={{
        ml: 0.5,
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        cursor: 'pointer',
      }}>
      here
    </Box>
  );

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            {getViewTitle(viewStateEnum.LANDING)}
          </Typography>
          <Button
            onClick={onCloseModal}
            sx={{
              backgroundColor: theme.palette.primary.transparent,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: theme.palette.primary.transparent,
              },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ margin: '30px 0' }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            Notice
          </Typography>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ padding: '0 20px' }}>
          <Typography fontSize="16px" fontWeight="bold" color="rgba(0, 0, 0, 0.8)">
            Adding device by MAC Address required devcie to support Nuclias Unity Auto Provision, meaning with correct firmware version and reset to factory default.
          </Typography>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ margin: '30px 0', padding: '0 20px', display: 'none' }}>
          You may check detail information {hereElement}.
        </Box>
        <Box className={modalStyle['modal_operation']}>
          <SolidButton
            className={modalStyle['modal_saveBtn']}
            style={{ width: '195px', height: '42px', fontSize: '16px' }}
            variant="contained"
            onClick={() => changeViewState(viewStateEnum.MAIN)}
          >
            I Understand
          </SolidButton>
        </Box>
      </Box>
    </>
  );
}

export default LandingView;
